import { faqCusto, faqProgramar } from './shared'
import type { ProfessionPageConfig } from './types'

export const professores: ProfessionPageConfig = {
  path: '/ia-para-professores/',
  key: 'professores',
  title: 'IA para professores: menos tempo fora da sala | Oficina IA',
  description:
    'Três tarefas fora da sala que a IA adianta numa pasta: lista de exercícios em três níveis, relatório por aluno e bilhetes para as famílias.',
  imageAlt: 'Oficina IA: IA para professores',
  whatsappMessage: 'Olá, Arthur. Vim pela página de IA para professores e quero saber sobre o acompanhamento.',
  lastmod: '2026-09-25',
  heading: 'IA para professores',
  intro:
    'Eu dou aula para adultos há mais de dez anos e sei que o trabalho pesado começa quando a aula acaba: prova, lista, relatório, bilhete. Aqui estão três tarefas desse pedaço que a IA pode ajudar a adiantar, sem programar.',
  rogerio: { pose: 'pensando', text: 'A aula é sua. O resto dá para dividir.' },
  tasks: [
    {
      title: 'Lista de exercícios em três níveis',
      tone: 'sky',
      brings: 'o conteúdo da semana e um exemplo de exercício seu.',
      helps: 'monta a lista em três níveis, no seu estilo, com gabarito.',
      continues: 'escolhe, corrige o que quiser e imprime.',
    },
    {
      title: 'Relatório por aluno',
      tone: 'peach',
      brings: 'a planilha de notas e as suas observações.',
      helps: 'escreve um relatório por aluno a partir do que você anotou.',
      continues: 'lê cada um antes de entregar. A avaliação é sua.',
    },
    {
      title: 'Bilhetes e comunicados',
      tone: 'sage',
      brings: 'a lista de alunos e o recado da semana.',
      helps: 'escreve um bilhete por família, com o nome certo.',
      continues: 'revisa e envia.',
    },
  ],
  steps: {
    do: 'A IA monta a lista, o relatório ou os bilhetes dentro da sua pasta.',
    check: 'Leia o que saiu antes de entregar. A IA pode se enganar; a nota e a palavra final são suas.',
    resume: 'Na semana seguinte, troque o conteúdo ou a lista e repita o pedido.',
  },
  faq: [
    faqProgramar,
    {
      question: 'A IA vai corrigir as provas?',
      answer: 'Nas tarefas desta página, ela prepara e organiza. A correção e a nota continuam com você; ela pode adiantar um gabarito para você conferir.',
    },
    {
      question: 'Serve para escola pública?',
      answer: 'Podemos partir das tarefas de qualquer professor que use computador. Se você usa o computador da escola, combine quais ferramentas e informações pode usar com quem cuida disso.',
    },
    faqCusto,
  ],
  closing: {
    title: 'Sua primeira lista pronta, com alguém do lado.',
    text: 'Traga a lista, a prova ou o relatório que está tomando a sua noite.',
    rogerio: 'Eu cuido do novelo. Você cuida da aula.',
  },
}
